// extracted by mini-css-extract-plugin
export default {"component":"ExternalLink_component__XWRHG"};